<template>
    <div class="rhp">
        <div class="rhp-veh gap-2 mb-2 d-flex align-items-center">
            <VehicleNameDisplay v-if="balise" :balise="balise" />
        </div>

        <div class="small-text row g-0 text-center border-top pt-2 mb-2">
            <div class="col-12 mb-2">
                <small class="fw-bold">Départ </small>
                <small class="text-muted">{{ drive.displayStartDate }}</small>
                <div><small>{{ drive.startAddress }}</small></div>
            </div>
            <div class="col-12">
                <hr class="my-2" />
            </div>
            <div class="col-12 mb-2">
                <small class="fw-bold">Arrivée </small>
                <small class="text-muted">{{ drive.displayEndDate }}</small>
                <div><small>{{ drive.endAddress }}</small></div>
            </div>
        </div>

        <div class="row g-0 align-items-center mb-3">
            <div class="col text-start"><small class="fw-bold">Durée :</small></div>
            <div class="col text-start px-1"><small>{{ drive.duration }}</small></div>
        </div>
        <div class="row g-0 align-items-center mb-3">
            <div class="col text-start"><small class="fw-bold">Distance :</small></div>
            <div class="col text-start px-1"><small>{{ drive.distance }} km</small></div>
        </div>

        <div class="d-grid">
            <router-link class="btn btn-outline-primary" :to="'/drivepositions/' + drive.id">
                Voir le détail
            </router-link>
        </div>

        <!-- ✅ Création corridoring (visuellement décorrélé, sous "Voir le détail") -->
        <div v-if="isAdmin" class="corr-create mt-3">
            <div class="corr-create__title d-flex align-items-center justify-content-between mb-2">
                <small class="fw-bold">Créer un corridoring</small>
                <small class="text-muted">Trajet #{{ drive.id }}</small>
            </div>

            <div class="input-group input-group-sm">
                <input v-model.trim="name" type="text" class="form-control" placeholder="Nom du corridoring"
                    :disabled="saving" @input="$emit('reset-create-feedback')"
                    @keyup.enter="submitCreate" />
                <button class="btn btn-outline-primary" :disabled="!canSubmit" @click="submitCreate">
                    <span v-if="saving" class="spinner-border spinner-border-sm me-1" />
                    Créer
                </button>
            </div>

            <div v-if="successMsg" class="small text-success mt-2">{{ successMsg }}</div>
            <div v-if="errorMsg" class="small text-danger mt-2">{{ errorMsg }}</div>
        </div>
    </div>
</template>

<script>
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'

export default {
    name: 'RightHistoryPanel',
    props: {
        balise: { type: Object, required: false, default: null },
        drive: { type: Object, required: true },
        // ✅ Pilotés par le parent (centralisation API)
        saving: { type: Boolean, default: false },
        successMsg: { type: String, default: '' },
        errorMsg: { type: String, default: '' },
    },
    components: {
        VehicleNameDisplay,
    },
    emits: ['create-corridoring', 'reset-create-feedback'],
    data() {
        return { name: '' };
    },
    computed: {
        isAdmin() {
            // ✅ utilise tes getters globaux (main.js)
            return this.$isAdmin === true;
        },
        canSubmit() {
            return this.isAdmin && !this.saving && this.drive?.id && this.name?.length > 0;
        },
    },
    watch: {
        // ✅ si succès côté parent, on nettoie le champ
        successMsg(v) {
            if (v) this.name = '';
        },
    },
    methods: {
        submitCreate() {
            if (!this.canSubmit) return;
            this.$emit('create-corridoring', { driveId: this.drive.id, name: this.name });
        },
    },
};
</script>

<style scoped>
.rhp {
    font-size: .95rem;
}

.small-text {
    font-size: 0.9em;
}
</style>